import { Injectable, EventEmitter } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { Http, RequestOptions, Headers, Response } from "@angular/http";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";

// Interfaces
import {
	IService,
	IApplication,
	IState,
	IStateModel,
	IStatesModel,
	ICountriesModel,
	ICountry,
	ICountryModel,
	IError,
	IStepModel,
	IApplicationModel,
	IApplicationsModel,
	IReviewer,
	IReviewerModel,
	IReviewersModel,
	IQuestionModel
} from "../../interfaces";
// enums
import { RoleEnum, ApplicationStatusEnum } from "../../enums";
// Services
import { LogService } from "../log/log.service";
import { ServerService } from "../server/server.service";
import { LoaderService } from "../loader/loader.service";
import { PromptService } from "../prompt/prompt.service";
import { TOUCHEND_HIDE_DELAY } from "@angular/material";

@Injectable()
export class HelperService implements IService {
	// implements local variables
	_states: BehaviorSubject<IStateModel[]> = new BehaviorSubject(undefined);
	_countries: BehaviorSubject<ICountryModel[]> = new BehaviorSubject(
		undefined
	);
	_phoneTypes: BehaviorSubject<string[]> = new BehaviorSubject(undefined);

	_data: {
		states: IStateModel[];
		countries: ICountryModel[];
		phoneTypes: string[];
	};

	OnModuleClicked$ = new EventEmitter(true);
	readonly CANNOTGOFORWARD = `At this time, your ED does not meet the minimum requirements for PACED Accreditation. We look forward to your application in the future.`;

	readonly SELECTQCREVIEWER = `Select the QC Reviewer`;

	readonly SAVESTALECHANGES = `Please save your application information before continuing.`;

	readonly DOWNLOAD =
		"We are preparing your download. Thank You for your patience.";
	// implements IService
	name = "HelperService";
	test(name, value) {
		console.log("testing", name, value);
	}

	constructor(
		private _serverSrv: ServerService,
		private _logSrv: LogService,
		private _loaderSrv: LoaderService,
		private _promptSrv: PromptService,
		private _router: Router
	) {
		this.getCountries();
		this.getStates();
	}

	get DATA() {
		if (this._data === undefined) {
			this._data = {
				countries: undefined,
				phoneTypes: undefined,
				states: undefined
			};
		}
		return this._data;
	}

	get PHONETYPES() {
		if (this.DATA.phoneTypes === undefined) {
			this.PhoneTypes = ["Home", "Mobile", "Hospital", "Business"];
		}
		return this._phoneTypes;
	}

	set PhoneTypes(value: string[]) {
		if (this.DATA.phoneTypes === undefined) {
			this.DATA.phoneTypes = value;
			this._phoneTypes.next(value);
		}
	}

	get STATES() {
		return this._states;
	}

	set States(value: IStateModel[]) {
		if (this.DATA.states === undefined) {
			this.DATA.states = value;
			this._states.next(value);
		}
	}

	get COUNTRIES() {
		return this._countries;
	}

	set Countries(value: ICountryModel[]) {
		if (this.DATA.countries === undefined) {
			this.DATA.countries = value;
			this._countries.next(value);
		}
	}

	getStates() {
		this._logSrv.Debug(this.name, ["getStates"]);
		this._serverSrv
			.GetWithAuth("A00000", `${environment.APILocation}helpers/states`)
			.subscribe(
				response => {
					const body = response.json();
					this._logSrv.Debug(this.name, [
						"getStates",
						{ response: response, body: body }
					]);
					const model = body.States;
					this.States = model;
				},
				Err => {
					this._logSrv.Error(this.name, ["getStates", Err]);
				}
			);
	}

	getCountries() {
		this._logSrv.Debug(this.name, ["getCountries"]);
		this._serverSrv
			.GetWithAuth(
				"A00000",
				`${environment.APILocation}helpers/countries`
			)
			.subscribe(
				response => {
					const body = response.json();
					this._logSrv.Debug(this.name, [
						"getCountries",
						{ response: response, body: body }
					]);
					const model = body.Countries;
					this.Countries = model;
				},
				Err => {
					this._logSrv.Error(this.name, ["getCountries", Err]);
				}
			);
	}

	getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
	}

	getTerms(): string {
		return environment.base.Termsandcondition;
	}

	goToMain() {
		this._loaderSrv.SetLoading(this.name, true);
		this._router.navigate(["/main"]);
	}

	goToMainSuppressLevel(level: Number) {
		this._loaderSrv.SetLoading(this.name, true);
		this._router.navigate(["/main"], {
			queryParams: { nolevel: level }
		});
	}

	goToMainWithLevel(level: Number, supress: boolean) {
		this._loaderSrv.SetLoading(this.name, true);
		this._router.navigate(["/main"], {
			queryParams: supress ? { nolevel: level } : { yeslevel: level }
		});
	}

	goToLogin() {
		this._loaderSrv.SetLoading(this.name, true);
		this._router.navigate(["/login"]);
	}

	goToMyAccount() {
		let acctPath = "/membership/dashboard";

		if (this.env === "development") {
			acctPath = `/ACEP${acctPath}`;
		}

		window.location.href = environment.BaseUrl + acctPath;
		this._loaderSrv.SetLoading(this.name, true);
		// this._router.navigate([acctPath])
		// 	.then(success => {

		// 	})
		// 	.catch(err => {
		// 		this.goToMain();
		// 	}
		// 	);
	}

	goToApplications(contactid: string) {
		this._loaderSrv.SetLoading(this.name, true);
		this._router
			.navigate(["/applications/home", { id: contactid }])
			.then(success => { });
	}

	goTo(url: string) {
		this._logSrv.Debug(this.name, ["goToStep", window]);
		this._router.navigateByUrl(url);
	}

	goToApplication(model: IApplicationModel) {
		this.goToLevel(model.Application.Level, model.Application.Id);
	}

	goToLevel(level: number, guid: string, isUpgrade: boolean = false) {
		this._logSrv.Debug(this.name, ["goToLevel", +level, guid]);
		this._loaderSrv.SetLoading(this.name, true);

		switch (+level) {
			case 3:
			case 2:
			case 1:
				if (isUpgrade) {
					this._router.navigate([
						`/levels/level${+level}/information`,
						guid
					]);
				} else {
					this._router.navigate([
						`/levels/level${+level}/information`,
						guid
					]);
				}
				break;

			default:
				this._loaderSrv.SetLoading(this.name, false);
		}
	}

	goToLevelWithStep(level: number, guid: string, step: string) {
		this._logSrv.Debug(this.name, ["goToLevel", +level, guid]);
		this._loaderSrv.SetLoading(this.name, true);
		switch (+level) {
			case 3:
				this._router.navigate([`/levels/level3/${step}`, guid]);
				break;
			case 2:
				this._router.navigate([`/levels/level2/${step}`, guid]);
				break;
			case 1:
				this._router.navigate([`/levels/level1/${step}`, guid]);
				break;
			default:
				this._loaderSrv.SetLoading(this.name, false);
		}
		//scroll to top of page
		$("html, body").animate({ scrollTop: 0 }, "fast");
	}

	// goToApproval(guid: string) {
	// 	this._logSrv.Debug(this.name, ['goToLevel', guid]);
	// 	this._loaderSrv.SetLoading(this.name, true);
	// 	this._router.navigate(['/approval/home', guid]);

	// 	this._loaderSrv.SetLoading(this.name, false);
	// }

	goToDetail(appModel: IApplicationModel) {
		//this._logSrv.Debug(this.name, ['goToLevel', appModel.Application.Id]);
		this._loaderSrv.SetLoading(this.name, true);

		if (appModel.Application.Status == ApplicationStatusEnum.Initiated) {
			this.goToApplication(appModel);
		} else {
			this._router.navigate(["/detail/home", appModel.Application.Id]);
		}
	}

	// goToRightOutlet(id) {
	// 	this._router.navigate(
	// 		[
	// 			{
	// 				outlets: { member: ['applications', 'home', id] }
	// 			}
	// 		]);
	// }

	isUndefined(obj: any) {
		return obj === undefined || obj === null || obj === "";
	}

	get Authorization() {
		return environment.Token;
	}
	get ApiLocation() {
		return environment.APILocation;
	}

	get ApiPayment() {
		return environment.paymentUrl;
	}

	get Url() {
		return environment.url;
	}

	get newHospitalId() {
		return environment.base.ManuallyEnterInfoId;
	}

	get env() {
		return environment.Evn;
	}

	async prompt(prompt: IError): Promise<boolean> {
		let wedonehere = false;
		const wdh = await this._promptSrv.showPrompt$.emit(prompt);
		wedonehere = true;
		return wedonehere;
	}

	hidePrompt() {
		this._promptSrv.hidePrompt$.emit();
	}

	getNumberOfDaysTillNow(date1: Date): number {
		var diff = Math.abs(date1.getTime() - Date.now());
		var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
		return diffDays;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/helper/helper.service.ts